import type { Chapter, Course } from '@mc/api'
import { EventTypes, track, getPageSource } from '@mc/track-event'

export interface trackPropsType {
  action?: string
  location: string
  content_type?: string
  class?: string | null
  page_category?: string
  category?: string | null
  href?: string
  episode?: string
  [x: string]: unknown
}

export const trackCTAClicked = (
  course: Course,
  episode: Chapter,
  trackProps: trackPropsType | undefined,
) => {
  const properties = {
    active_annual_pass: false,
    // TODO: determine if content_ids is needed and if so what value
    // content_ids: 304,
    page_source: getPageSource(),
    page_path: window.location.pathname,
    type: 'all-access-pass',
    ...trackProps,
  }

  if (episode?.slug) {
    properties.episode = episode.slug
  }

  if (course?.slug) {
    properties.class = course.slug
  }

  track(EventTypes.PURCHASE_CLICK, properties)
}
